import {api} from "../services/api";

export const crudDoperationAPI = (data) => {
  return api.post(`CRUD/sqlquery/CRUDoperation`, data);
}